  export interface CentralFrame {
    name: string;
    id: number;
    no_central_overhang: boolean;
    guarantee_active: boolean;
    low_salary_active: boolean;
    low_salary_rename: boolean;
    cao?: ValuePercent;
    cdo?: ValuePercentMonth;
    cag?: ValuePercent;
    cdg?: ValuePercentMonth;
    calv?: ValuePercent;
    cdlv?: ValuePercentMonth;
    cga?: ValuePercent;
    cgav?: ValuePercentMonth;
    cagl?: ValuePercent;
    cdgl?: ValuePercentMonth;
    ed_avg?: number;
    c_avg?: number;
  }

  export function newCentralFrame(): CentralFrame {
    return {
      name: "",
      id: 0,
      no_central_overhang: false,
      guarantee_active: false,
      low_salary_active: false,
      low_salary_rename: false,
      ed_avg: 0,
      c_avg: 0,
    }
  }
  
  interface ValuePercent {
    val: number;
    percent: number;
  }
  
  interface ValuePercentMonth extends ValuePercent {
    month: number;
  }

  export interface LocalInfo {
    /** Kr pr time */
    LAvgH: number;
    /** gjennomsnitt mnd.lønn i januar */
    LLAM: number;
    /** gjennomsnitt mnd.lønn i fjor */
    LUM: number;
    /** dato for tillegg i år */
    LLAD: number;
    /** medlemmer med garantiregularing */
    MwG: number;
    /** medlemmer totalt */
    MwGT: number;
  }

  export function newLocalInfo(): LocalInfo {
    return {
      LAvgH: 0,
      LLAM: 0,
      LUM: 0,
      LLAD: 0,
      MwG: 0,
      MwGT: 0,
    }
  }

  export interface LocalFrame {
    id: number;
    name: string;
  
    // Local additions - A
    lao: Entry;   // Lokalt overheng
    lag: Entry;   // Generelle tillegg
    lalv: Entry;  // Lavlønnstillegg
    gt: Entry;    // Garantitillegg
    lagl: Entry;  // Glidning / lokale tillegg
    latf: Entry;  // SUM RAMME
  
    // Local additions - D
    ldo: Entry;   // Lokalt overheng
    ldg: Entry;   // Generelle tillegg
    ldlv: Entry;  // Lavlønnstillegg
    gtv: Entry;   // Garantitillegg
    ldgl: Entry;  // Glidning / lokale tillegg
    ldt: Entry;   // SUM RAMME
  
    // Additional numeric values
    lnd: number;  // From
    lnh: number;  // Kr pr time
    lny: number;  // Pr måned
    lnp: number;  // Pr år
    lnm: number;  // %
  }

  export interface Entry {
    percent: number;  // corresponds to Percent in .NET
    val: number;      // corresponds to Val in .NET
    month: number;    // corresponds to Month in .NET
  }

  export function newLocalFrame(): LocalFrame {
    return {
      id: 0,
      name: "",

      // Local additions - A
      lao: {percent: 0, month: 0, val: 0},   // Lokalt overheng
      lag: {percent: 0, month: 0, val: 0},  // Generelle tillegg
      lalv: {percent: 0, month: 0, val: 0},  // Lavlønnstillegg
      gt: {percent: 0, month: 0, val: 0},    // Garantitillegg
      lagl: {percent: 0, month: 0, val: 0},  // Glidning / lokale tillegg
      latf: {percent: 0, month: 0, val: 0},  // SUM RAMME
      
      // Local additions - D
      ldo: {percent: 0, month: 0, val: 0},   // Lokalt overheng
      ldg: {percent: 0, month: 0, val: 0},   // Generelle tillegg
      ldlv: {percent: 0, month: 0, val: 0},  // Lavlønnstillegg
      gtv: {percent: 0, month: 0, val: 0},   // Garantitillegg
      ldgl: {percent: 0, month: 0, val: 0},  // Glidning / lokale tillegg
      ldt: {percent: 0, month: 0, val: 0},   // SUM RAMME
      
      // Additional numeric values
      lnd: 0,  // From
      lnh: 0,  // Kr pr time
      lny: 0,  // Pr måned
      lnp: 0,  // Pr år
      lnm: 0,  // %
    }
  }